

export default {
  methods: {
    async getOptions() {
      const response = await this.$http.get(process.env.VUE_APP_API_URL + 'api/v1/options', {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('z_token'),
        }
      })
      return response.body.json
    },
    async handleImageAdded (file, Editor, cursorLocation, resetUploader) {
      const base64String = await this.converToBase64(file)

      this.$http.post(process.env.VUE_APP_AWS_URL + 'upload/image', {
        'storage_name': 'musigahealthcare',
        'base64String': base64String
      }, {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('z_token')
        }
      }).then(function (response) {

        if (response.data.result) {
          // Editor.insertEmbed(cursorLocation, 'image', response.data.result)
          Editor.pasteHTML(cursorLocation, `<img src="${response.data.result}">`);
        }
      }).catch(function (error) {
        console.log(error)
      })
    },
    async converToBase64(file) {
      return new Promise((resolve, reject) => {
        var reader = new FileReader()
        reader.onload = ((theFile) => {
          return (e) => {
            var binaryData = e.target.result;
            //Converting Binary Data to base 64
            var base64String = window.btoa(binaryData);
            //showing file converted to base64
            resolve(base64String)
          }
        })(file)
        // Read in the image file as a data URL.
        reader.readAsBinaryString(file);
      })
    }
  }
}